import React, { useEffect, useState } from "react";
import unsplash from "../api/unsplash";
import GlobalSnackbar from "./Snackbar";
import LinearProgress from "@mui/material/LinearProgress";

import {
  Grid,
  Box,
  Card,
  CardContent,
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  Button,
  ButtonGroup,
  Zoom,
  DialogActions,
  DialogContentText,
} from "@mui/material";

import EditIcon from "@mui/icons-material/Edit";

import { IconButton } from "@mui/material";

import {
  DataGridPro,
  itIT,
  GridToolbarContainer,
  GridToolbarQuickFilter,
} from "@mui/x-data-grid-pro";
import { CustomFooterPersonalized } from "../utils/CustomFooterPersonalized";

import { Add, Delete, Close, Check } from "@mui/icons-material";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Zoom timeout={2000} in={true} ref={ref} {...props} />;
});

export const GruppiParita = () => {
  const [gruppiParita, setGruppiParita] = useState([]);
  const [loading, setLoading] = useState(true);
  const [anagraficaSelezionata, setGruppiSelezionata] = useState([]);

  const [open, setOpen] = useState(false);
  const [openAlert, setOpenAlert] = useState(false);
  const [openSnack, setOpenSnack] = useState(false);
  const [snack, setSnack] = useState({
    severity: "success",
    messaggio: "Salvataggio Effettuato correttamente",
    open: false,
  });
  const handleCloseSnack = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnack(false);
  };

  const columns = [
    {
      filterable: false,
      field: "Actions",
      headerName: "Azioni",
      hide: false,
      width: "130",
      headerAlign: "center",
      align: "center",
      renderCell: (params) => (
        <>
          <IconButton
            aria-label="edit"
            onClick={async () => {
              await setGruppiSelezionata(params.row);
              document.getElementById("edit").click();
              handleClickOpen();
            }}
          >
            <EditIcon
              style={{ height: "2rem", width: "2rem", color: "#2265B1" }}
            />
          </IconButton>

          <DeleteDialog gruppi={params.row} myFunction={handleDelete} />
        </>
      ),
    },
    {
      field: "Descrizione",
      headerName: "Descrizione",
      flex: 1,
      align: "center",
      headerAlign: "center",
    },
  ];

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const reloadAfterUpload = async () => {
    let response = await unsplash.get("gruppiParita", {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("jwt")}`,
      },
    });

    setGruppiParita(response.data.data);
  };

  const handleSave = async (gruppi, operazione) => {
    if (operazione === "new") {
      try {
        await unsplash.post(
          "gruppiParita",
          {
            gruppo: gruppi,
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("jwt")}`,
            },
          }
        );
        setSnack({
          severity: "success",
          messaggio: "Mansione creata con successo",
        });
        setOpenSnack(true);

        reloadAfterUpload();
      } catch {
        setSnack({
          severity: "error",
          messaggio: "Errore durante la creazione",
        });
        setOpenSnack(true);
      }
      handleClose();
    } else {
      try {
        await unsplash.put(
          "gruppiParita",
          { gruppo: gruppi },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("jwt")}`,
            },
          }
        );
        setSnack({
          severity: "success",
          messaggio: "Mansione aggiornata con successo",
        });
        setOpenSnack(true);

        reloadAfterUpload();
      } catch {
        setSnack({
          severity: "error",
          messaggio: "Errore durante l'aggiornamento",
        });
        setOpenSnack(true);
      }
      handleClose();
    }
  };

  const handleDelete = async (gruppi) => {
    try {
      await unsplash.delete("gruppiParita", {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("jwt")}`,
        },
        data: {
          id: gruppi,
        },
      });

      setSnack({
        severity: "success",
        messaggio: "Mansione eliminata con successo",
      });
      setOpenSnack(true);
      reloadAfterUpload();
    } catch {
      setSnack({
        severity: "error",
        messaggio: "Errore durante l'eliminazione della Mansione",
      });
      setOpenSnack(true);
    }
  };

  function CustomToolbar() {
    return (
      <GridToolbarContainer>
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
        >
          <GridToolbarQuickFilter placeholder="Cerca..." />
        </Grid>
      </GridToolbarContainer>
    );
  }

  useEffect(() => {
    (async () => {
      try {
        let response = await unsplash.get("gruppiParita", {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("jwt")}`,
          },
        });

        setGruppiParita(response.data.data);
        setLoading(false);
      } catch (error) {
        console.error(error.message);
      }
    })();
  }, []);
  return (
    <>
      <GlobalSnackbar
        severity={snack.severity}
        messaggio={snack.messaggio}
        openSnack={openSnack}
        handleCloseSnack={handleCloseSnack}
      />
      <Grid item xs={12}>
        <Card>
          <CardContent sx={{ p: { xs: 0 } }}>
            <Grid item xs={12}>
              <Card>
                <CardContent>
                  <Grid
                    container
                    direction="row"
                    spacing={2}
                    alignItems="center"
                    justifyContent="flex-end"
                  >
                    <Grid item xs={12} md={4}>
                      <Grid
                        container
                        direction="row"
                        alignItems="center"
                        justifyContent="flex-end"
                      >
                        <Gruppo
                          id="edit"
                          gruppi={anagraficaSelezionata}
                          saveFunction={handleSave}
                          title="Modifica Gruppo"
                        />
                        <Gruppo
                          id="new"
                          gruppi={anagraficaSelezionata}
                          saveFunction={handleSave}
                          title="Nuovo Gruppo"
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                  <Box
                    sx={{
                      height: { xs: "75vh", md: "60vh", xl: "75vh" },
                      width: 1,
                    }}
                  >
                    {gruppiParita?.length > 0 && (
                      <DataGridPro
                        initialState={{
                          pinnedColumns: { left: ["Actions"] },
                        }}
                        components={{
                          Toolbar: CustomToolbar,
                          Footer: CustomFooterPersonalized,
                        }}
                        slots={{
                          loadingOverlay: LinearProgress,
                        }}
                        loading={loading}
                        localeText={
                          itIT.components.MuiDataGrid.defaultProps.localeText
                        }
                        rowHeight={52}
                        rows={gruppiParita}
                        columns={columns}
                        getRowId={(row) => row.ID}
                        pageSize={20}
                        rowsPerPageOptions={[20]}
                        disableSelectionOnClick
                      />
                    )}
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
    </>
  );
};

/* Creazione Nuovi Formatori */
const Gruppo = (props) => {
  const [open, setOpen] = useState(false);
  const [openAlert, setOpenAlert] = useState(false);
  const [checked, setChecked] = useState(false);
  const [gruppi, setGruppi] = useState({
    Descrizione: "",
  });

  const handleClickOpen = () => {
    if (props.id === "edit") {
      setGruppi(props.gruppi);
    } else {
      setGruppi({
        Descrizione: "",
      });
    }
    setOpen(true);
  };
  const handleClose = () => {
    /* setGruppi(newGruppo); */
    setOpen(false);
  };
  const handleChange = (e) => {
    let copiaGruppo = { ...gruppi };
    copiaGruppo[e.target.name] = e.target.value;
    setGruppi(copiaGruppo);
  };
  const handleSave = async () => {
    props.saveFunction(gruppi, props.id);
    handleClose();
  };

  return (
    <>
      <ButtonGroup
        variant="contained"
        aria-label="outlined primary button group"
      >
        {props.id === "edit" ? (
          <Button
            startIcon={<Add />}
            onClick={handleClickOpen}
            id={props.id}
            sx={{ color: "white", display: "none" }}
            variant="outlined"
            className="ButtonMiller"
          >
            Aggiungi
          </Button>
        ) : (
          <Button
            startIcon={<Add />}
            onClick={handleClickOpen}
            id={props.id}
            sx={{ color: "white" }}
            variant="outlined"
            className="ButtonMiller"
          >
            Aggiungi
          </Button>
        )}
      </ButtonGroup>

      <Grid
        container
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Dialog
          open={open}
          onClose={handleClose}
          fullWidth={true}
          maxWidth="xs"
          TransitionComponent={Transition}
        >
          {/* Title Container */}
          <DialogTitle
            sx={{
              mx: "auto",
            }}
          >
            {props.title}
          </DialogTitle>
          {/* Body Container */}
          <DialogContent>
            {/* Row 2 */}
            <Grid container>
              <Grid item xs={12}>
                <TextField
                  value={gruppi.Descrizione}
                  id="outlined-basic"
                  label="Descrizione"
                  name="Descrizione"
                  onChange={handleChange}
                  fullWidth
                  sx={{ mt: 2 }}
                />
              </Grid>
            </Grid>
            {/* Bottoni Salva & Esci */}
          </DialogContent>
          <DialogActions
            xs={12}
            sx={{
              display: "flex",
              justifyContent: "space-between",
              mx: 2,
            }}
          >
            <Button
              onClick={handleClose}
              variant="contained"
              className="ButtonMiller"
              startIcon={<Close />}
            >
              Chiudi
            </Button>
            <Button
              onClick={handleSave}
              variant="contained"
              className="ButtonMiller"
              startIcon={<Check />}
            >
              Salva
            </Button>
          </DialogActions>
        </Dialog>
      </Grid>
    </>
  );
};
const DeleteDialog = (props) => {
  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <IconButton aria-label="edit" onClick={handleClickOpen}>
        <Delete style={{ height: "2rem", width: "2rem", color: "#FF2768" }} />
      </IconButton>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title" sx={{ mx: "auto" }}>
          Sei sicuro di voler eliminare la Qualifica Contrattuale selezionata?
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Attenzione, sei sicuro di voler eliminare la seguente Qualifica Contrattuale :
            <br />
            <b>{props.gruppi.Descrizione}</b>
          </DialogContentText>
        </DialogContent>
        <DialogActions
          sx={{
            display: "flex",
            justifyContent: "space-between",
            px: 3,
          }}
        >
          <Button onClick={handleClose}>annulla</Button>
          <Button onClick={() => props.myFunction(props.gruppi.ID)}>
            Conferma
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};
